import {GetEmployeeMechanicsApiResponse} from '@dms/api/customer';

import {Nullish} from 'shared/web';

export type BasketMechanic = {
  mechanics: GetEmployeeMechanicsApiResponse | Nullish;
  areMechanicsLoading: boolean;
  selectedMechanicId: string | null;
  onMechanicChange: (mechanicId: string | number | string[] | null) => void;
  mechanicError?: string;
  isMechanicRequired?: boolean;
};
